module.exports = __webpack_public_path__ + "img/hr-tree-05-e-leaves.4f813b9b.png";